import { render, staticRenderFns } from "./MethodologicalStrategyView.vue?vue&type=template&id=09f2cdc7&scoped=true"
import script from "./MethodologicalStrategyView.vue?vue&type=script&lang=js"
export * from "./MethodologicalStrategyView.vue?vue&type=script&lang=js"
import style0 from "./MethodologicalStrategyView.vue?vue&type=style&index=0&id=09f2cdc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f2cdc7",
  null
  
)

export default component.exports